import { render, staticRenderFns } from "./psp-lx.vue?vue&type=template&id=8bea1e30&"
import script from "./psp-lx.vue?vue&type=script&lang=ts&"
export * from "./psp-lx.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports